const MOBILE_BREAKPOINT = 375;

export const isMobileView = () => window.outerWidth <= MOBILE_BREAKPOINT;

const asyncTimeOut = (cb, timeOut = 0) => new Promise(((resolve, reject) => {
    setTimeout(() => {
        cb({ resolve, reject });
    }, timeOut);
}));

export const resolveAfterTimeout = (value, timeOut) => () => asyncTimeOut(({ resolve }) => resolve(value), timeOut);
